module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iaVRF"))).then(() => parcelRequire('cvs7o'));